// src/config/workerPackTemplates.js

const WORKER_PACK_TEMPLATES = [
    {
      template_id: 890247,
      pack_name: 'Bronze Worker Pack',
      img: require('../assets/pack/bronze_worker.webp'), 
      mint_cost: {
        first: '400.0000 TOOL',
        second: '60.0000 RCOIN'
      },
      mint_consume: 100,
    },
    {
      template_id: 890248,
      pack_name: 'Silver Worker Pack',
      img: require('../assets/pack/silver_worker.webp'),
      mint_cost: {
        first: '800.0000 TOOL',
        second: '120.0000 RCOIN'
      },
      mint_consume: 200,
    },
    {
      template_id: 890249,
      pack_name: 'Gold Worker Pack',
      img: require('../assets/pack/gold_worker.webp'),
      mint_cost: {
        first: '1600.0000 TOOL',
        second: '240.0000 RCOIN'
      },
      mint_consume: 300,
    },
    {
      template_id: 890250,
      pack_name: 'Diamond Worker Pack',
      img: require('../assets/pack/diamond_worker.webp'),
      mint_cost: {
        first: '3200.0000 TOOL',
        second: '480.0000 RCOIN'
      },
      mint_consume: 400,
    }
  ];

 const MAP_WORKER_PACKS = [
   {
     pack: 890247,
     workers: [890190, 890192, 890193]
   },
    {
      pack: 890248,
      workers: [890194, 890195, 890196]
    },
    {
      pack: 890249,
      workers: [890197, 890198, 890199]
    },
    {
      pack: 890250,
      workers: [890200, 890201, 890202]
    }
 ];

  export { WORKER_PACK_TEMPLATES, MAP_WORKER_PACKS };
